import { DISTRIBUTION_BASE, PAYROLL_FREQUENCY, PAYROLL_PAYMENT_ON } from './payroll-template-enum';

const DISTRIBUTION_BASE_OPTION = Object.freeze([
    {
        text: 'All Equal',
        value: DISTRIBUTION_BASE.AMOUNT,
    },
    {
        text: 'Tier Based',
        value: DISTRIBUTION_BASE.TIER,
    },
    {
        text: 'Team Based',
        value: DISTRIBUTION_BASE.TEAM,
    },
]);

const PAYROLL_FREQUENCY_OPTION = Object.freeze([
    {
        text: 'Monthly',
        value: PAYROLL_FREQUENCY.MONTHLY,
        per: 'Per Month',
    },
    {
        text: 'Semi-Monthly',
        value: PAYROLL_FREQUENCY.SEMI_MONTHLY,
        per: 'Per Semi-Month',
    },
    {
        text: 'Weekly',
        value: PAYROLL_FREQUENCY.WEEKLY,
        per: 'Per Week',
    },
]);

const PAYROLL_PAYMENT_ON_OPTION = Object.freeze([
    {
        text: '1st Payroll',
        value: PAYROLL_PAYMENT_ON.FIRST,
    },
    {
        text: '2nd Payroll',
        value: PAYROLL_PAYMENT_ON.SECOND,
    },
    {
        text: '3rd Payroll',
        value: PAYROLL_PAYMENT_ON.THIRD,
    },
    {
        text: '4th Payroll',
        value: PAYROLL_PAYMENT_ON.FOURTH,
    },
    {
        text: '',
        value: PAYROLL_PAYMENT_ON.NONE,
    },
]);

export { DISTRIBUTION_BASE_OPTION, PAYROLL_FREQUENCY_OPTION, PAYROLL_PAYMENT_ON_OPTION };
